import '@/embed-base'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 创建全局事件总线
Vue.prototype.$bus = new Vue()

import { checkMiniProgramEnv } from '@/common/env.js'

import '@/common/axios'
import '@/common/utils.js'

Vue.prototype.$bus = new Vue()

// 引入自定义指令
import './directives/lazyBackground'
import './directives/html-image-style'
import './directives/html-video-poster'

// 导入图标库
import '@/assets/fonts/iconfont.css'

//默认头像
import avatar from '@/assets/images/common/avatar.png'
import userAvatar from '@/assets/images/common/avatar-default.jpg'
import officialAvatar from '@/assets/images/common/avatar-Official.jpg'
Vue.prototype.defaultAvatar = avatar
Vue.prototype.defaultUserAvatar = userAvatar
Vue.prototype.defaultOfficialAvatar = officialAvatar

//可解决多个message同时显示问题
import { message } from './common/message'
Vue.prototype.$message = message

// 地址配置
Vue.prototype.$apiURL = process.env.VUE_APP_API_BASE_URL
Vue.prototype.$webURL = process.env.VUE_APP_WEB_URL
Vue.prototype.$miniAppID = process.env.VUE_APP_MINIAPP_ID
Vue.prototype.$miniAppVersion = process.env.VUE_APP_MINIAPP_VERSION
Vue.prototype.$amapJsKey = process.env.VUE_APP_AMAP_JS_KEY
Vue.prototype.$amapJsKeySecurityJsCode = process.env.VUE_APP_AMAP_JS_KEY_SECURITYJSCODE
Vue.prototype.$TencentJsKey = process.env.VUE_APP_TENCENT_JS_KEY
Vue.prototype.$comunityCommentShowHide = process.env.VUE_APP_COMMUNITY_COMMENT_SHOWHIDE

// 时间处理
import moment from 'moment' //导入文件
Vue.prototype.$moment = moment //赋值使用

// 路由query合并
import merge from 'webpack-merge'
Vue.prototype.$merge = merge

// 图片懒加载
import VueLazyload from 'vue-lazyload'
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
})

// element-ui（按需引入）
import 'element-ui/lib/theme-chalk/index.css'
import {
  Pagination,
  Input,
  Dialog,
  Empty,
  Loading,
  Image,
  Tooltip,
  Checkbox,
  Upload,
  Drawer,
  DatePicker,
} from 'element-ui'
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(Image)
Vue.use(Tooltip)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Drawer)
Vue.use(DatePicker)

// vant（按需引入）
import '@vant/touch-emulator' //pc端支持vant，一些手机触摸等事件转化为pc支持的事件
// import { Tabs, Tab, Dialog as VanDialog, Toast, Popup } from 'vant' // 引入Button组件
import {
  Tabs,
  Tab,
  Toast,
  Popup,
  Sticky,
  List,
  Search,
  Field,
  Button,
  Form,
  CountDown,
  Tabbar,
  TabbarItem,
  ActionSheet,
  Popover,
  Calendar,
  Picker,
  Area,
  Badge,
  Uploader,
  DatetimePicker,
  Cell,
  Switch,
  Stepper,
  Swipe,
  SwipeItem,
} from 'vant' // 引入组件
import 'vant/lib/index.css'
Vue.use(Tabs)
Vue.use(Tab)
// Vue.use(VanDialog)
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Sticky)
Vue.use(List)
Vue.use(Search)
Vue.use(Field)
Vue.use(Button)
Vue.use(Form)
Vue.use(CountDown)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(ActionSheet)
Vue.use(Popover)
Vue.use(Calendar)
Vue.use(Picker)
Vue.use(Area)
Vue.use(Badge)
Vue.use(Uploader)
Vue.use(DatetimePicker)
Vue.use(Cell)
Vue.use(Switch)
Vue.use(Stepper)
Vue.use(Swipe)
Vue.use(SwipeItem)

// 全局注册
// import Vant from "vant"
// import 'vant/lib/index.css';
// Vue.use(Vant)

function mountApp() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}

// 微信 iframe 里 getEnv 可能永不回调；超时或失败也必须挂载，否则 #app 一直空
checkMiniProgramEnv().then(mountApp).catch(mountApp)
